import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {KeycloakService} from 'keycloak-angular';
import {Subject} from 'rxjs/internal/Subject';
import {takeUntil} from 'rxjs/internal/operators/takeUntil';
import {UserService} from 'src/app/services/user.service';
import {WebiatLogoutComponent} from '../webiat-logout/webiat-logout.component';
import {ActivatedRoute, NavigationEnd, Router, RouterEvent} from '@angular/router';
import {NavigationService} from 'src/app/services/navigation.service';
import {filter} from 'rxjs';
import { CommentsService } from 'src/app/services/comments.service';

export const ICON_LIST = [
  { name : 'switchIcon' , path :'assets/icons/dots-vertical.svg'},
  { name : 'posts' , path :'assets/icons/posts.svg'},
  { name : 'users' , path :'assets/icons/users.svg'},
  { name : 'users-active' , path :'assets/icons/users-active.svg'},
  { name : 'comments-active' , path :'assets/icons/comments-active-icon.svg'},
  { name : 'comments' , path :'assets/icons/comments-icon.svg'},
  { name : 'clubs-active' , path :'assets/icons/clubs-active.svg'},
  { name : 'clubs' , path :'assets/icons/clubs.svg'},
  { name : 'postsGrey' , path :'assets/icons/posts-grey.svg'},
  { name : 'logout' , path :'assets/icons/logout.svg'},
  { name : 'trainings-active' , path :'assets/icons/trainings-active.svg'},
  { name : 'trainings' , path :'assets/icons/trainings.svg'},
  { name : 'credit-active' , path :'assets/icons/credit-active.svg'},
  { name : 'credit' , path :'assets/icons/credit.svg'},
  { name : 'amical', path :'assets/icons/amical-icon.svg'},
  { name : 'amical-active', path :'assets/icons/amical-icon-active.svg'},
  { name : 'employee-reimbursement', path :'assets/icons/employee-reimbursement.svg'},
  { name : 'employee-reimbursement-active', path :'assets/icons/employee-reimbursement-active.svg'},
  {name : 'notification', path :'assets/icons/notification-inactive.svg'},
  {name : 'notification-active', path :'assets/icons/notification-active.svg'},
   {name : 'parametrage', path :'assets/icons/sliders.svg'},
   {name : 'parametrage-active', path :'assets/icons/sliders-active.svg'},
   {name : 'career', path :'assets/icons/expertRH_icon.svg'},
   {name : 'career-active', path :'assets/icons/expertRH_icon-active.svg'}



]
interface NavItem {
  name: string;
  routerLink: string;
  icon: string;
  activeIcon: string;
  role : string[]
}

@Component({
  selector: 'app-webiat-drawer',
  templateUrl: './webiat-drawer.component.html',
  styleUrls: ['./webiat-drawer.component.scss'],
})
export class WebiatDrawerComponent implements OnInit, OnDestroy {
  private unsubscribe$: Subject<void> = new Subject<void>();
  public navList: NavItem[] = [
    { name: 'Gestion de contenu', routerLink: 'content-managment', icon: 'postsGrey', activeIcon: 'posts' , role : ['ROLE_CM'] },
    { name: 'Gestionnaire de carrière', routerLink: 'career-management', icon: 'career', activeIcon: 'career-active', role: ['ROLE_ADMIN', 'ROLE_ERH'] },
    {name: 'Paramétrage', routerLink: 'parametrage', icon: 'parametrage', activeIcon: 'parametrage-active', role: ['ROLE_ADMIN']},
    { name: 'Gestion des collaborateurs', routerLink: 'collaborator-list', icon: 'users', activeIcon: 'users-active', role : ['ROLE_ADMIN'] },
    { name: 'Gestion des commentaires', routerLink: 'comments', icon: 'comments', activeIcon: 'comments-active', role : ['ROLE_CM'] },
    { name: 'Gestion des clubs', routerLink: 'clubs-overview', icon: 'clubs', activeIcon: 'clubs-active', role : ['ROLE_CLM'] },
/*     { name: 'Gestion des formations', routerLink: 'training-managment', icon: 'trainings', activeIcon: 'trainings-active', role : 'ROLE_TM' }, */
    { name: 'Gestion de crédit', routerLink: 'credit-management', icon: 'credit', activeIcon: 'credit-active', role : ['ROLE_CD', 'ROLE_CR', 'ROLE_CO'] },
    {name: 'Gestion de l’amicale', routerLink: 'amical-management',icon: 'amical',activeIcon: 'amical-active',role: ['ROLE_AM']},
    {name: 'Gestion de déplacement', routerLink: 'employee-reimbursement-management',icon: 'employee-reimbursement',activeIcon: 'employee-reimbursement-active',role: ['ROLE_ERM']},
    {name: 'Gestion des notifications', routerLink: 'notification-management',icon: 'notification',activeIcon: 'notification-active',role: ['ROLE_GN']}, 
    

  ];
  public agentFirstName!: string;
  public agentLastName!: string;
  public role!: string;
  public imageUrl!: string;
  private id!: string;
  public showButtonLogout: boolean = false;

  url !:string 
  count !:number

  initials: string = '';
  backgroundColor: string = '';
  letterColor: string = '';
  private listBackgroundColors = [
    "#E0EEF5", "#E0E9F5", "#FBEFDB", "#FAE5DB", "#FDF5D9", "#EDEAE9"
  ];
  private listLetterColors = [
    "#2B6788", "#254676", "#BB8217", "#833711", "#AD8D0B", "#5A5149"
  ];
  public firstName!: string;
  public lastName!: string;

  constructor(
    private userService: UserService,
    private keycloakAngular: KeycloakService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    public navService: NavigationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commentService : CommentsService
  ) {

    ICON_LIST.forEach( elt =>{
      this.iconRegistry.addSvgIcon( elt.name , this.sanitizer.bypassSecurityTrustResourceUrl(elt.path))
    })
    
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd)
      ).subscribe((res : any) =>{      
      this.getCountNotVerifiedComments()
    })
    
  }

  async ngOnInit(): Promise<void> {
    const isAuthenticated = await this.keycloakAngular.isLoggedIn();
    if (isAuthenticated) {
      // Get the Keycloak instance
      const keycloakInstance = this.keycloakAngular.getKeycloakInstance();

      // Check if idTokenParsed is defined
      if (keycloakInstance?.idTokenParsed) {

        this.keycloakAngular.loadUserProfile().then(profile => {
          if (profile?.firstName) {
            this.agentFirstName = profile?.firstName;
          }
          if (profile?.lastName) {
            this.agentLastName = profile?.lastName;
          }

        })
      }
    }

    this.userService
      .getUserInfo()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((dataSource) => {
        this.role = dataSource['role']['name'];
        this.id = dataSource['externalId'];
        this.firstName = dataSource['firstname'];
        this.lastName = dataSource['lastname'];
        this.userService
          .getUserPhoto(this.id)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((imageBlob: Blob) => {
            this.imageUrl = URL.createObjectURL(imageBlob);
            
          },
          (error) => {
            console.error('Erreur lors du chargement de l\'image : ', error);
            this.imageUrl = ''; 
            this.setInitialsAndColors();
          });
      });

    this.setActiveNavItem();

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.setActiveNavItem();
    });
  }

  private setActiveNavItem(): void {
    const currentRoute = this.activatedRoute.snapshot.firstChild?.routeConfig?.path;
    const activeNavItem = this.navList.find(item => item.routerLink === currentRoute);
    if (activeNavItem) {
      this.navService.setActiveItem(activeNavItem.routerLink);
    }
  }

  public navigateTo(routerLink: string): void {
    this.navService.setActiveItem(routerLink);
    this.router.navigateByUrl(routerLink);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public showLogoutBtn(): void {
    this.showButtonLogout = !this.showButtonLogout;
  }

  public openDialog(): void {
     this.dialog.open(WebiatLogoutComponent, {
      width: '400px',
    });
  }

  @HostListener('document:click', ['$event.target']) onMouseClick(
    targetElement: any
  ) {
    const logoutWrapperClicked = document
      .getElementById('logoutWrapper')
      ?.contains(targetElement);
    const profileCardClicked = document
      .getElementById('profileCard')
      ?.contains(targetElement);
    if (!logoutWrapperClicked && !profileCardClicked) {
      this.showButtonLogout = false;
    }
  }

  getCountNotVerifiedComments(){
    this.commentService.getCountNotVerifiedComments().pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(res =>{
      this.count = res
    })
  }
  
  setInitialsAndColors() {
    if (this.firstName && this.lastName) {
      this.initials = `${this.firstName[0]?.toUpperCase()}${this.lastName[0]?.toUpperCase()}`;
      const colorIndex = (this.calculateAsciiSum(this.firstName) + this.calculateAsciiSum(this.lastName)) % 6;
      this.backgroundColor = this.listBackgroundColors[colorIndex];
      this.letterColor = this.listLetterColors[colorIndex];
    }
  }

  calculateAsciiSum(name: string): number {
    return name.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
  }

  authorizedSection(navList: NavItem[]): NavItem[] {
    let filtredList = navList.filter((elt: NavItem) => {
      return elt.role.some((role: string) => this.keycloakAngular.getUserRoles().includes(role));
    });
    
    return filtredList;
  }
}
